import React, { useEffect, useState } from 'react'

import './moveOn.css'

const GOOGLE_PLAY_URL =
    'https://play.google.com/store/apps/details?id=com.jamaisvuca.justnow'
const APP_STORE_URL =
    'https://apps.apple.com/us/app/justnow/id1561946002?l=fr&ls=1'

const features = [
    {
        icon: '📍',
        title: 'Événements autour de vous',
        desc: 'Découvrez ce qui se passe près de chez vous en temps réel.',
    },
    {
        icon: '🏪',
        title: 'Gérez votre établissement',
        desc: 'Créez et administrez votre page en quelques clics.',
    },
    {
        icon: '📢',
        title: 'Publiez facilement',
        desc: 'Partagez vos événements et touchez votre audience locale.',
    },
]

export default function MoveOn() {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => setVisible(true), 100)
        return () => clearTimeout(timer)
    }, [])

    return (
        <div className="moveon">
            {/* Animated background orbs */}
            <div className="moveon__orb moveon__orb--1" />
            <div className="moveon__orb moveon__orb--2" />
            <div className="moveon__orb moveon__orb--3" />

            <div className={`moveon__content ${visible ? 'moveon__content--visible' : ''}`}>
                {/* Hero section */}
                <header className="moveon__hero">
                    <div className="moveon__logo-glow" />
                    <img
                        src={require('../../assets/app_name.png')}
                        alt="JustNow"
                        className="moveon__logo"
                    />
                    <h1 className="moveon__headline">
                        Passez à l'application
                        <span className="moveon__headline-accent"> mobile</span>
                    </h1>
                    <p className="moveon__subline">
                        Rendez-vous sur nos applications pour créer et gérer votre
                        établissement et vos publications.
                    </p>
                </header>

                {/* Features */}
                <section className="moveon__features">
                    {features.map((f, i) => (
                        <div
                            key={f.title}
                            className="moveon__feature"
                            style={{ animationDelay: `${0.3 + i * 0.12}s` }}
                        >
                            <span className="moveon__feature-icon">{f.icon}</span>
                            <div>
                                <h3 className="moveon__feature-title">{f.title}</h3>
                                <p className="moveon__feature-desc">{f.desc}</p>
                            </div>
                        </div>
                    ))}
                </section>

                {/* Store buttons */}
                <section className="moveon__stores">
                    <a
                        href={GOOGLE_PLAY_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="moveon__store-link"
                    >
                        <img
                            src={require('../../assets/gl.png')}
                            alt="Disponible sur Google Play"
                            className="moveon__store-badge"
                        />
                    </a>
                    <a
                        href={APP_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="moveon__store-link"
                    >
                        <img
                            src={require('../../assets/ap.png')}
                            alt="Disponible sur l'App Store"
                            className="moveon__store-badge"
                        />
                    </a>
                </section>

                {/* Bottom decoration */}
                <div className="moveon__footer-line" />
            </div>
        </div>
    )
}

// import React from 'react'
// import { Zoom } from "react-awesome-reveal"
//
// // Style
// import './moveOn.css'
// import Row from "react-bootstrap/Row"
// import Col from "react-bootstrap/Col"
// import Image from "react-bootstrap/Image"
// import Container from "react-bootstrap/Container"
//
// export default function MoveOn() {
//
//     return (
//         <Container>
//             <Row>
//                 <Col xs={12}>
//                     <div className='moveon-container'>
//                         <Zoom>
//                             <Image src={require('../../assets/app_name.png')} fluid/>
//                         </Zoom>
//                         <h1 className='moveon-title'>Rendez-vous sur nos applications pour créer et gérer votre
//                             établissement et vos publications.</h1>
//                         <div className='moveon-store-container '>
//                             <ul className="list-inline moveon-ul-container">
//                                 <li>
//                                     <a target="_blank"
//                                        href='https://play.google.com/store/apps/details?id=com.ekrak&utm_source=global_co&utm_medium=prtnr&utm_content=Mar2515&utm_campaign=PartBadge&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img
//                                         className="img-responsive" width="200em" alt='Disponible sur Google Play'
//                                         src={require('../../assets/gl.png')}/></a>
//
//                                 </li>
//                                 <li>
//                                     <a target="_blank"
//                                        href='https://itunes.apple.com/us/app/ekrak/id1217014035?l=fr&ls=1&mt=8'><img
//                                         className="img-responsive" width="200em" alt='Disponible sur Google Play'
//                                         src={require('../../assets/ap.png')}/></a>
//
//                                 </li>
//                             </ul>
//                         </div>
//                     </div>
//                 </Col>
//             </Row>
//         </Container>
//     )
// }
//
//
//
